import { useContext } from "react";
import { LoggingContext } from "./Logging.context.tsx";

export const useLogging = () => {
  const context = useContext(LoggingContext);

  if (!context) {
    throw new Error("useLogging() must be used within LoggingProvider");
  }

  return context;
};
